import React from 'react';
import PropTypes from 'prop-types';

import {Grid, GridItem} from 'pac-ux-components';

import {NavLink} from 'react-router-dom';

import {I18n} from '@aws-amplify/core';

const FooterRow = ({ account }) => {
    const links = [
        {
            label: I18n.get('Forgot password') + '?',
            path: '/reset-password/selection/' + account.id,
        },
    ];

    return (
        <Grid justifyContent="strech">
            <GridItem>
                {links.map((link, index) => (
                    <NavLink to={link.path} key={index}>
                        <p className="navigation-link">{link.label}</p>
                    </NavLink>
                ))}
            </GridItem>
        </Grid>
    );
};

export default FooterRow;

FooterRow.propTypes = {
    account: PropTypes.object,
};
